import React, { useContext, useState } from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import Dialog from '@mui/material/Dialog'
import { useTheme } from '@mui/material/styles'
import api from '../../lib/api'
import axios from 'axios'
import { SimpleSnackbarContext } from '../SimpleSnackbar'
import { UserContext } from '../UserProvider'

const AddReferralCodeDialog: React.FC<{ handleClose: () => void }> = ({ handleClose }) => {
  const theme = useTheme()
  const { refetch } = useContext(UserContext)
  const { actions: snackActions } = useContext(SimpleSnackbarContext)
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))
  const [code, setCode] = useState<string>('')
  const [error, setError] = useState<string>('')

  const validate = async () => {
    try {
      await api.addInviteCode(code)
      await refetch()
      handleClose()
      snackActions.open('This code is valid!')
    } catch (error) {
      if (axios.isAxiosError(error)) {
        // @ts-ignore
        const { code, message } = error.response.data
        if (code === '1034') {
          setError('You already input a code')
          return
        }
        if (code === '1035') {
          setError('This code is invalid')
          return
        }
        if (code) {
          setError(message)
          return
        }
      }
      setError('Internal server error.')
    }
  }

  return (
    <Dialog fullScreen={fullScreen} open={true} fullWidth maxWidth="sm">
      <DialogTitle>Add a referral code</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ paddingBottom: 3 }}>
          If you received a referral code from another Rakonto user or affiliate, please enter the code here
        </DialogContentText>
        <TextField
          name="code"
          placeholder="Type the code"
          fullWidth
          margin="dense"
          variant="outlined"
          value={code}
          onChange={e => setCode(e.target.value)}
          error={!!error}
          helperText={error || ' '}
        />
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="outlined" autoFocus onClick={() => validate()} disabled={!code}>
          Validate
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AddReferralCodeDialog
